import { isValidForm, isValidFormField, buttonLoader, clearForm } from '../utilities/form-functions'
import { playAudio, stopAudio } from '../elements/audio-player'

let $body = $('body')
let yourStoryPopup = $('.js-your-story-form-popup')
let canAjax = true
let textLinks = $('.form-success').find('a')

textLinks.each(function (e){
  $(this).addClass('nodeHover')
})

function openYourStoryPopup()
{


  $(".js-your-story-form-popup").show()
  stopAudio()

}

function closeYourStoryPopup()
{
  let popup = $(".js-your-story-form-popup")
  let form = popup.find('form')
  let formContent = form.find('.form-content')
  let formSuccess = form.find('.form-success')

  form.find('.selected').removeClass('selected')
  form.find('.add-image').removeClass('d-none')
  form.find('.edit-image').addClass('d-none')
  form.find('.update-user-image').attr('style', '')
  form.find('.letter-count').text('0')
  formContent.show()
  formSuccess.hide()
  popup.hide()
  clearForm($(this).find('form'))

}

$body.on('click', '.js-check-recording', function (e){
  e.preventDefault()

  let button = $(this)
  let storyTextField = button.closest('form').find('.user-story-text')
  let story = storyTextField.find('textarea').val()

  if(isValidFormField(storyTextField, true)) {

    buttonLoader(button, true)
    button.addClass('playing')
    stopAudio()

    if(canAjax) {

      canAjax = false

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          'action' : 'check_story',
          'story' : story
        },
        success: function (results) {

          if(results.success === 1) {
            playAudio(results.recording, button)
          }

          buttonLoader(button, false)
          canAjax = true

        },
      })
    }

  } else {
    storyTextField.addClass('has-error')
  }

  return false

})

$body.on('submit', '#submit-story-form', function (e){
  //e.preventDefault()
  let form = $(this)
  let button = form.find('[type="submit"]')
  let formContent = form.find('.form-content')
  let formSuccess = form.find('.form-success')

  buttonLoader(button, true)

  if(isValidForm(form, true) && canAjax) {

    canAjax = false
    stopAudio()


    let formData = new FormData(this)

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: formData,
      success: function (results) {

        setTimeout(function (){

          if(results.success === 1) {

            formContent.hide()
            formSuccess.fadeIn()


            clearForm(form)

          } else {

          }

          buttonLoader(button, false)
          canAjax = true

        }, 500)

      },
      async: false,
      cache: false,
      contentType: false,
      processData: false,
      enctype: 'multipart/form-data',
    })

  } else {
    buttonLoader(button, false)
  }

  return false

})

$body.on('click', '.js-open-your-story-form', function (e){
  e.preventDefault()
  openYourStoryPopup()
})

$body.on('click', '.js-your-story-form-popup .js-close-popup', function (e){
  e.preventDefault()
  closeYourStoryPopup()

})

$body.on('click', '.js-reload-page-popup', function (e){
  window.location = window.location.href
})

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closeYourStoryPopup()
  }
});